'use client';

import { FC, PropsWithChildren, useMemo } from 'react';
import { createPortal } from 'react-dom';

import { useScrollBlock } from '@/hooks/scroll';

import {
  ScModal,
  ScModalBg,
  ScModalContainer,
  ScModalContent,
  ScModalContentProps,
  ScModalProps,
} from './styled';

export interface GeneralModalProps {
  isPortal?: boolean;
  disableScrollBlock?: boolean;
}

export type ModalProps = PropsWithChildren &
  ScModalContentProps &
  ScModalProps &
  GeneralModalProps;

export const Modal: FC<ModalProps> = ({
  children,
  verticalAlign,
  fullHeight,
  padding,
  isPortal,
  disableScrollBlock,
  ...props
}) => {
  useScrollBlock(false, disableScrollBlock);

  const modalComponent = useMemo(
    () => (
      <ScModal {...props}>
        <ScModalBg {...props} />
        <ScModalContainer>
          <ScModalContent
            verticalAlign={verticalAlign}
            fullHeight={fullHeight}
            padding={padding}
          >
            {children}
          </ScModalContent>
        </ScModalContainer>
      </ScModal>
    ),
    [verticalAlign, fullHeight, padding, children, props]
  );

  return isPortal
    ? createPortal(modalComponent, document.body)
    : modalComponent;
};
